import React from 'react'
import { object, string } from 'prop-types'

import Loader from 'Pods/Shared/Loader'
import Icon from 'Pods/Shared/Icon/Icon'
import UserBox from 'Pods/Shared/UserSearch/UserBox'

function CurrentUser({ user, label }) {
  const { id } = user || {}

  if (user === undefined) {
    return (
      <div
        className={
          'cgt-alert cgt-legacy-back-color-utility-attention-20 '
          + 'cgt-legacy-color-utility-attention-100 cgt-mb-20'
        }
      >
        <div className="cgt-alert__icon">
          <Icon type={['far', 'info-circle']} notSpaced />
        </div>
        <div className="cgt-alert__message">User was not found.</div>
      </div>
    )
  }

  if (user && user.id) {
    return (
      <div className="row">
        <div className="col-12 col-md-6 col-lg-4 col-xl-3">
          <div className="form-group form-group-grey">
            <label>{label}</label>

            <UserBox attributes={user} scope="sellers" boxClass="card" />
          </div>
        </div>
      </div>
    )
  }

  return (
    <Loader isFullHeight />
  )
}

CurrentUser.propTypes = {
  user: object,
  label: string.isRequired,
}

export default CurrentUser
